import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import DatatableTables from "../../globals/core/Tables/DatatableTables";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CurrentUser } from "./CurrentUser";
import { setUsers } from "../../store/actions/usersActions";
import { showLoader } from "../../store/actions/mainActions";
import { UsersService } from "../../globals/services/users.service";
import avatar from "./../../assets/images/user.png";
import {Button, Input, Label} from "reactstrap";
import { getCommunities, getCourses } from "../../store/actions/contentActions";
import { ReactComponent as MoveNext } from '../../assets/images/move_right.svg';
import { ReactComponent as MovePrevious } from '../../assets/images/move_left.svg';

export const Users = (props) => {
  const { courses, communities } = useSelector((state) => state.content)
  const { users } = useSelector((state) => state.users);
  const [preFilterUserList, setPreFilterUserList] = useState([]);
  const [filterRole, setFilterRole] = useState('All');
  const [filterStatus, setFilterStatus] = useState('All');
  const [filterMobile, setFilterMobile] = useState('All');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalUsersInDb, setTotalUsersInDb] = useState(0);
  const [filterName, setFilterName] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [deleteUser, setDeleteUser] = useState(null);
  const dispatch = useDispatch();
  const usersService = UsersService();

  const invite = async (e, uid) => {
    try {
      e.stopPropagation();
      const usersService = UsersService();
      await usersService.invite(uid);
    } catch (err) {
      console.error(err);
    }
  }

  const resetPassword = async (e, uid) => {
    try {
      e.stopPropagation();
      const usersService = UsersService();
      await usersService.resetpassword(uid);
    } catch (err) {
      console.error(err);
    }
  }

  const fetchUsers = async () => {
    try {
      dispatch(showLoader(true));
      // if ((courses?.length === 0) || communities?.length === 0) {
      await dispatch(getCommunities());
      //await dispatch(getCourses());
      // }

      const totalUsersInDB = await usersService.getLengthOfUsersDB();
      setTotalUsersInDb(totalUsersInDB.data)
      const users = await usersService.filterUsersForUserModule(currentPage+30);
      if (users) {
        dispatch(setUsers(users.filter(u => u.email !== undefined)));
        setPreFilterUserList(users.filter(u => u.email !== undefined));
      }
      dispatch(showLoader(false));
    } catch (err) {
      console.error(err);
      dispatch(showLoader(false));
    }
  };


  useEffect(() => {

    if (!currentUser)
      fetchUsers();

  }, [dispatch, currentUser]);

  const inviteBtn = (user, indx) => {
    return (
      <div
        key={indx + "invite"}
        className="d-flex align-items-center justify-content-start"
      >
        <Button color="primary" onClick={(e) => invite(e, user._id)}>
          Invite
        </Button>
      </div>
    );
  };

  const deleteConfirm = async (e, uid) => {
    setDeleteUser(uid);
  };

  const finalDelete = async () => {
    try {
      const usersService = UsersService();
      await usersService.deleteUser(deleteUser);


      dispatch(showLoader(true));
      const users = await usersService.getAll();
      if (users) {
        dispatch(setUsers(users.filter(u => u.email !== undefined)));
      }
      dispatch(showLoader(false));

      setDeleteUser(null);
    } catch (err) {
      console.error(err);
    }
  };

  const deleteBtn = (user, indx) => {
    return (
        <div
            key={indx + "invite"}
            className="d-flex align-items-center justify-content-start"
        >
          <Button color="danger" onClick={(e) => deleteConfirm(e, user._id)}>
            Delete
          </Button>
        </div>
    );
  };


  const resetPasswordBtn = (user, indx) => {
    return (
      <div
        key={indx + "invite"}
        className="d-flex align-items-center justify-content-start"
      >
        <Button color="primary" onClick={(e) => resetPassword(e, user._id)}>
          Reset
        </Button>
      </div>
    );
  };  

  const tUsers = users.map((u, indx) => {
    return {
      statusChanged: moment(u?.statusChanged).format('MM-DD-YYYY'),
      status: u.banned ? 'banned' : u.status,
      entity: u,
      name: u,
      role: u?.role,
      email: u?.email,
      termsApproved: u?.termsApproved ? 'Yes' : 'No',
      mobileDeviceId: u?.mobileDeviceId ? 'Yes' : 'No',
      invite: inviteBtn(u, indx),
      resetpassword: resetPasswordBtn(u, indx),
      delete: deleteBtn(u, indx),
      inviteDate: moment(u?.inviteDate).format('MM-DD-YYYY'),
    };
  });

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setCurrentUser(row.entity);
      document.querySelector(".currentUserSection").classList.add('currentUserSectionOpened');

    },
  };

  const columns = [
    {
      dataField: "name",
      text: "NAME",
      sort: true,
      formatter: (cell) => {
        return (
          <Fragment>
            <div className="d-flex justify-content-sart align-items-center">
              <img
                className="rounded-circle avatar-sm"
                src={cell.image ? cell.image : avatar}
                alt={"avatar"}
              />
              <div className="mx-2 d-flex flex-column">
                <h5 className=" d-inlone-block">
                  {cell.fullName}
                  {cell.banned ? ' (banned) ' : ''}
                </h5>
              </div>
            </div>
          </Fragment>
        )
      },
      sortValue: (cell) => {
        return cell.firstName;
      },
      searchValue: (cell) => {
        return cell.firstName;
      },
      searchable: true
    },
    {
      dataField: "email",
      text: "EMAIL",
      sort: true,
    },
    {
      dataField: "role",
      text: "ROLE",
      sort: true,
    },
    {
      dataField: "termsApproved",
      text: "TERMS",
      sort: true,
    },    
    {
      dataField: "mobileDeviceId",
      text: "MOBILE",
      sort: true,
    }
  ];

  const moveToNextPage = async (e) => {
    e.preventDefault();

    try {
      const users = await usersService.paginateUsersForUserModule(currentPage + 30, 30);
      if (users) {
        dispatch(setUsers(users.filter(u => u.email !== undefined)));
        setPreFilterUserList(users.filter(u => u.email !== undefined));
        setCurrentPage(currentPage + 30);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const moveToPreviousPage = async (e) => {
    e.preventDefault();
    try {
      const users = await usersService.paginateUsersForUserModule(currentPage - 30, 30);
      if (users) {
        dispatch(setUsers(users.filter(u => u.email !== undefined)));
        setPreFilterUserList(users.filter(u => u.email !== undefined));
        setCurrentPage(currentPage - 30);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const clearFilter = () => {
    dispatch(setUsers(preFilterUserList));
    setFilterRole('All');
    setFilterStatus('All');
    setFilterMobile('All');
    setFilterName(null);
  };

  const filterData = (e, field, value) => {
    if (field === 'role') {
      if (value !== 'All') {
        setFilterRole(value);
        setFilterName(null);
        setFilterStatus('All');
        setFilterMobile('All');
        dispatch(setUsers(preFilterUserList.filter(u => u.role === value)));
      } else {
        setFilterRole('All');
        setFilterName(null);
        setFilterStatus('All');
        setFilterMobile('All');
        dispatch(setUsers(preFilterUserList));
      }
    } else if (field === 'status') {
      if (value !== 'All') {
        setFilterStatus(value);
        setFilterName(null);
        setFilterRole('All');
        setFilterMobile('All');
        dispatch(setUsers(preFilterUserList.filter(u => u.status === value)));
      } else {
        setFilterStatus('All');
        setFilterName(null);
        setFilterRole('All');
        setFilterMobile('All');
        dispatch(setUsers(preFilterUserList));
      }
    } else if (field === 'mobile') {
      if (value !== 'All') {
        setFilterStatus('All');
        setFilterName(null);
        setFilterRole('All');
        setFilterMobile(value);
        if (value === 'mobile') {
          dispatch(setUsers(preFilterUserList.filter(u => u.mobileDeviceId !== undefined)));
        } else {
          dispatch(setUsers(preFilterUserList.filter(u => u.mobileDeviceId === undefined)));
        }
      } else {
        setFilterStatus('All');
        setFilterName(null);
        setFilterRole('All');
        setFilterMobile('All');
        dispatch(setUsers(preFilterUserList));
      }
    }
  };

  const filterByName = async (e, field, value) => {
    if (field === 'name') {
      if (value.length > 2) {
        setFilterStatus('All');
        setFilterRole('All');
        //dispatch(setUsers(preFilterUserList.filter(u => u.fullName.toLowerCase().includes(value.toLowerCase()))));
        const users = await usersService.filterUsersForUserModule(value);
        dispatch(setUsers(users.filter(u => u.email !== undefined)));
        setPreFilterUserList(users.filter(u => u.email !== undefined));
      } else {
        setFilterStatus('All');
        setFilterRole('All');
        dispatch(setUsers(preFilterUserList));
      }
    }
  };

  return (
    <div className="content">

      <div className="page-content">
        <div className="container-fluid">
          <div className="mb-3">
            <Breadcrumbs title="MAIN" breadcrumbItem="USERS MANAGEMENT" />
            <div>{totalUsersInDb ? totalUsersInDb : 0} users in DB | {tUsers ? tUsers.length : 0} users in view</div>
          </div>

          <div className="row mb-2">
            <div className="col-9 d-flex">

              <div className="form-group col-md-3 mr-2">
                <h5 className="mt-4"> <Label htmlFor="_name">Search users</Label></h5>
                <Input
                    id="searchName"
                    name="searchName"
                    placeholder="Search user by name or email..."
                    type="text"
                    onChange={(e) => filterByName(e, 'name', e.target.value)}
                />
              </div>
            </div>
            <h5 className="mt-4"> <Label htmlFor="_name">Filter view by:</Label></h5>
            <div className="col-9 d-flex">

              <div className="form-group col-md-2 ml-5">
                <h6 className="mt-2"> <Label htmlFor="_role">Role</Label></h6>
                <select className="form-control" id="exampleFormControlSelect1" value={filterRole} onChange={(e)=>filterData(e, 'role', e.target.value)}>
                  <option value="All">All</option>
                  <option value="Administrator">Administrator</option>
                  <option value="Community Manager">Community Manager</option>
                  <option value="Content Editor">Content Editor</option>
                  <option value="Member">Member</option>
                </select>
              </div>

              <div className="form-group col-md-2">
                <h6 className="mt-2"> <Label htmlFor="_status">Status</Label></h6>
                <select className="form-control" id="exampleFormControlSelect1"  value={filterStatus} onChange={(e)=>filterData(e, 'status', e.target.value)}>
                  <option value="All">All</option>
                  <option value="confirm">Confirm</option>
                  <option value="invited">Invited</option>
                  <option value="pending">Pending</option>
                </select>
              </div>

              <div className="form-group col-md-2">
                <h6 className="mt-2"> <Label htmlFor="_mobile">Mobile</Label></h6>
                <select className="form-control" id="exampleFormControlSelect1"  value={filterMobile} onChange={(e)=>filterData(e, 'mobile', e.target.value)}>
                  <option value="All">All</option>
                  <option value="mobile">Mobile</option>
                  <option value="desktop">Desktop Only</option>
                </select>
              </div>

              <div className="form-group col-md-3">
                <h6 className="mt-2"> <Label htmlFor="_clear">Actions</Label></h6>
                <div className="btn btn-primary" onClick={()=>clearFilter()}>Clear</div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-row mt-3 paginationContainer">
            <div className="paginationStatus">Showing users {currentPage} - {currentPage + 30 < totalUsersInDb ? currentPage + 30 : totalUsersInDb}</div>
            {currentPage > 0 ?  <div className="pagePrevious" onClick={(e)=>moveToPreviousPage(e)}><MovePrevious className="svgPagePrevious" /> Previous</div> : null}
            {currentPage + 30 < totalUsersInDb ?  <div className="pageNext" onClick={(e)=>moveToNextPage(e)}>Next <MoveNext className="svgPageNext"/></div> : null}
          </div>



          {deleteUser ? <div className="ConfirmDelContainer">
            <div>Are you sure?</div>
            <div className="ConfirmDelBtn" onClick={() => finalDelete()}>Confirm Delete</div>
          </div> : null}
          <div className="row justify-content-around">
            <div className="col-12">
              <DatatableTables
                columns={columns}
                data={tUsers}
                desc={""}
                rowEvents={rowEvents}
              ></DatatableTables>
            </div>
          </div>
          <div className="col-12 currentUserSection">
            <CurrentUser setCurrentUser={setCurrentUser} currentUser={currentUser}></CurrentUser>
          </div>
        </div>
      </div>
    </div>
  );
};
